import(/* webpackMode: "eager" */ "/private/tmp/claude-501/-Users-yongsu-code-JoySamOld/923d98c7-d55d-4270-8ed8-adb9a03d71ae/scratchpad/rel-fe/joysam-admin-front-end/app/(root)/layout.tsx");
